import React, { Component } from 'react'
import { connect } from 'react-redux'
import Select from 'react-select-v2'
import CurrentDetailsRow from './CurrentDetailsRow'
// import CurrentEarningsChart from './CurrentEarningsChart'
import i18n from '../../../i18n'
import './CurrentDetailsTable.css'
import { getEntityOption, getPeriodOption } from '../../../reducers/data'
import { setEntity, setPeriod, setRange, setEarningsType, setGrowthType } from '../../../actions/data'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleNotch, faFilePdf } from '@fortawesome/free-solid-svg-icons'
import ReactTooltip from 'react-tooltip'
import moment from 'moment'
import CurrentEarningsChart from './CurrentEarningsChart'

const logo = 'https://www.wisdomtree.com/investments/-/media/us-media-files/wisdomtree-tools/wt-wht-logo-tools.png'

library.add(faCircleNotch, faFilePdf)

const customStyles = {
  control: base => ({
    ...base,
    borderRadius: 0,
    boxShadow: 'none',
    width: 300
  }),
  option: provided => ({
    ...provided,
    color: '#050139',
    fontSize: 14,
    borderRadius: 0,
    border: '0px #8c959b',
    backgroundColor: 'white',
    ':hover': {
      backgroundColor: '#050139',
      color: 'white'
    }
  }),

  menu: base => ({
    ...base,
    borderRadius: 0,
    borderColor: '#8c959b'
  }),
  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1
    const transition = 'opacity 100ms'
    return { ...provided, opacity, transition }
  },

  multiValueLabel: (provided, state) => ({
    ...provided,
    color: 'white',
    fontSize: '10px',
    fontWeight: 'bold'
  }),
  dropdownIndicator: base => ({
    ...base,
    color: '#050139'
  })
}

class CurrentDetailsTable extends Component {
  setEarType(value) {
    this.props.setEarningsType(value)
  }

  setGrowthType(value) {
    this.props.setGrowthType(value)
  }
  setConstituentNum(value) {
    this.props.setConstituentNumber(value)
  }

  renderReportingDate() {
    const { earningsAggs } = this.props
    let date = new Date(earningsAggs[0].cutStamp)
    const options = { year: 'numeric', month: 'numeric', day: 'numeric' }
    return new Date(date).toLocaleDateString([], options)
  }

  formatDate(string) {
    const options = { year: 'numeric', month: 'numeric', day: 'numeric' }
    return new Date(string).toLocaleDateString([], options)
  }

  renderEarningsRows(category, earningsType) {
    const { earningsAggs, initialLoad } = this.props
    let earningsAggsFiltered = []
    if (earningsType === 'growth-all') {
      earningsAggsFiltered = earningsAggs.filter(x => x.tierOne === 'All')
    } else if (earningsType === 'growth-rpt') {
      earningsAggsFiltered = earningsAggs.filter(x => x.tierOne === 'Reported')
    } else if (earningsType === 'surprise') {
      earningsAggsFiltered = earningsAggs.filter(x => x.tierOne === 'Reported')
    }

    let itemIndex = earningsAggsFiltered.findIndex(item => item.tierTwo === 'Index')
    // detach the item and return it
    earningsAggsFiltered.splice(0, 0, earningsAggsFiltered.splice(itemIndex, 1)[0])

    if (initialLoad === false) {
      return (
        <tr>
          <td colSpan='11' style={{ textAlign: 'center' }}>
            <FontAwesomeIcon icon='circle-notch' size='3x' style={{ color: '#050139' }} spin />
          </td>
        </tr>
      )
    } else if (earningsAggsFiltered) {
      return earningsAggsFiltered.map((fund, idx) => {
        return <CurrentDetailsRow key={idx} data={fund} type={category} />
      })
    }
  }

  renderEarningsHeader(earningsType) {
    const { earningsAggs, earningsTickerListing } = this.props
    let displayTickerCode = earningsAggs[0].ticker
    let minDate = earningsAggs[0].dt
    const formattedDate = moment(minDate).format('MM/DD/YY')

    let displayRange = earningsAggs[0].displayRange
    let displayTickerName = earningsTickerListing.filter(x => x.ticker === displayTickerCode)

    let tableHeading = ''
    if (earningsType === 'growth-all') {
      tableHeading = 'GROWTH (ALL)'
    } else if (earningsType === 'surprise') {
      tableHeading = 'EARNINGS SURPRISE'
    } else {
      tableHeading = 'GROWTH (REPORTED)'
    }
    let tblHeader = earningsType.split('-')

    return (
      <thead>
        <tr>
          <th colSpan={earningsType === 'growth-all' ? 12 : 12} className='tickerHeader'>
            {displayTickerName[0].name} {displayRange} (As of {formattedDate})
            <img src={logo} className='tickerLogo' alt='' />
          </th>
        </tr>
        <tr>
          <th colSpan='1' className={'tableheading-textLeft'}>
            {tableHeading}
          </th>
          <th colSpan='1' className={`${'borderleft'} ${'borderbottom'} ${'textCenter'}`}>
            {i18n.t('Count').toUpperCase()}
          </th>
          {earningsType !== 'growth-all' && (
            <th colSpan='2' className={`${'borderleft'} ${'borderbottom'} ${'textCenter'}`}>
              {i18n.t('Weight').toUpperCase()}
            </th>
          )}
          {earningsType === 'growth-all' && (
            <th colSpan='1' className={`${'borderleft'} ${'borderbottom'} ${'textCenter'}`}>
              {i18n.t('Weight').toUpperCase()}
            </th>
          )}
          <th colSpan='2' className={`${'borderleft'} ${'borderbottom'} ${'textCenter'}`}>
            {tblHeader[0].toUpperCase()}{' '}
          </th>
        </tr>
        <tr>
          <th colSpan='1' className={'tableheading-textLeft'}>
            {i18n.t('Entity').toUpperCase()}
          </th>
          {earningsType === 'growth-all' && (
            <th colSpan='1' className={'borderleft'}>
              {i18n.t('Total').toUpperCase()}
            </th>
          )}
          {earningsType !== 'growth-all' && (
            <th colSpan='1' className={'borderleft'}>
              {i18n.t('Reported/Total').toUpperCase()}
            </th>
          )}
          {earningsType !== 'growth-all' && (
            <th colSpan='1' className={'textCenter'}>
              {i18n.t('% Weight Reported').toUpperCase()}
            </th>
          )}
          <th colSpan='1' className={'textCenter'}>
            {i18n.t('% Weight of Index').toUpperCase()}
          </th>
          <th colSpan='1' className={`${'borderleft'} ${'borderbottom'} ${'textCenter'}`}>
            {i18n.t('Sales').toUpperCase()}
          </th>
          <th colSpan='1' className={'tableheading-textCenter'}>
            {i18n.t('Earnings').toUpperCase()}
          </th>
        </tr>
      </thead>
    )
  }

  render() {
    const { earningsTickerListing, setEntity, setRange, setPeriod, selectedEntityOption, selectedPeriodOption, selectedRangeOption, entityOption, rangeOption, earningsType, periodOption } = this.props
    function arrayToFormOptions(values) {
      return values.map(item => ({ value: item, label: item }))
    }

    function valueToFormValue(value) {
      if (value && value.length > 0) {
        return value.map(item => ({ value: item, label: item }))
      } else {
        return null
      }
    }

    if (earningsTickerListing) {
      return (
        <div>

          {/* <div className='pdfLink'>
            <a href='https://www.wisdomtree.com/-/media/us-media-files/documents/resource-library/DailyEarningsDashboard.pdf' target='_new'>
              <FontAwesomeIcon icon='file-pdf' size='1x' style={{ color: '#050139' }} /> Download Daily Earnings Snapshot PDF
            </a>
          </div> */}
          <div className='row' >
            <div className='col-md-3' style={{ textAlign: 'left', paddingRight: '3px' }}>
              <Select
                placeholder={i18n.t('Select Entity')}
                styles={customStyles}
                isMulti={false}
                onChange={setEntity}
                options={arrayToFormOptions(entityOption)}
                value={valueToFormValue(selectedEntityOption)}
              // closeMenuOnSelect={false}
              />
            </div>
            <div className='col-md-1'></div>
            <div className='col-md-3' style={{ textAlign: 'left', paddingRight: '3px' }}>
              <Select
                placeholder={i18n.t('Select Range')}
                styles={customStyles}
                isMulti={false}
                onChange={setRange}
                options={arrayToFormOptions(rangeOption)}
                //isClearable
                value={valueToFormValue(selectedRangeOption)}
              // closeMenuOnSelect={false}
              />
            </div>
            <div className='col-md-1'></div>
            <div className='col-md-3' style={{ textAlign: 'left', paddingRight: '3px' }}>
              <Select
                placeholder={i18n.t('Select Period')}
                styles={customStyles}
                isMulti={false}
                onChange={setPeriod}
                options={arrayToFormOptions(periodOption)}
                value={valueToFormValue(selectedPeriodOption)}
              // closeMenuOnSelect={false}
              />
            </div>
          </div>
          <div className='earnings-buttons'>
            <button data-tip data-for='growth-all' onClick={() => this.setEarType('growth-all')} type='button'
              className={`earningsButton ${(earningsType === 'growth-all' ? 'isselected' : 'notselected')}`}>
              {i18n.t('growth-btn')}
            </button>
            <ReactTooltip id='growth-all' className='feetipn' place='top' type='light' effect='float'>
              A blend of actual reported sales and earnings growth <br /> with median analyst estimates.
            </ReactTooltip>
            <button data-tip data-for='growth-reported' onClick={() => this.setEarType('growth-rpt')} type='button'
              className={`earningsButton ${(earningsType === 'growth-rpt' ? 'isselected' : 'notselected')}`}>
              {i18n.t('growth-rpt-btn')}
            </button>
            <ReactTooltip id='growth-reported' className='feetipn' place='top' type='light' effect='float'>
              Actual reported sales and earnings growth
            </ReactTooltip>
            <button data-tip data-for='surprise' onClick={() => this.setEarType('surprise')} type='button'
              className={`earningsButton ${(earningsType === 'surprise' ? 'isselected' : 'notselected')}`}>
              {i18n.t('surprise-btn')}
            </button>
            <ReactTooltip id='surprise' className='feetipn' place='top' type='light' effect='float'>
              Difference between actual reported sales and earnings <br /> and median analyst estimates.
            </ReactTooltip>
            <span style={{ fontWeight: '400', color: '#5b6770', fontSize: '14px', textAlign: 'left', marginTop: '10px', paddingLeft: '33px', paddingRight: '3px' }}></span>
          </div>
          {earningsType === 'growth-all' && (
            <div className='earnings-details'>
              <div className='table-responsive'>
                <table className={'table table-earnings'}>
                  {this.renderEarningsHeader(earningsType)}
                  <tbody>{this.renderEarningsRows('growth', earningsType)}</tbody>
                </table>
              </div>

              <div className='col-md-6 col-sm-12' style={{ paddingLeft: '0px', marginBottom: '65px' }}>
                <CurrentEarningsChart type={'salesGrowth'} />
              </div>

              <div className='col-md-6 col-sm-12' style={{ paddingLeft: '0px', marginBottom: '65px' }}>
                <CurrentEarningsChart type={'earningsGrowth'} />
              </div>
            </div>
          )}
          {earningsType === 'growth-rpt' && (
            <div className='earnings-details'>
              <div className='table-responsive'>
                <table className={'table table-earnings'}>
                  {this.renderEarningsHeader(earningsType)}
                  <tbody>{this.renderEarningsRows('growth', earningsType)}</tbody>
                </table>
              </div>

              <div className='col-md-6 col-sm-12' style={{ paddingLeft: '0px', marginBottom: '65px' }}>
                <CurrentEarningsChart type={'salesGrowth'} />
              </div>

              <div className='col-md-6 col-sm-12' style={{ paddingLeft: '0px', marginBottom: '65px' }}>
                <CurrentEarningsChart type={'earningsGrowth'} />
              </div>
            </div>
          )}
          {earningsType === 'surprise' && (
            <div className='earnings-details'>
              <div className='table-responsive'>
                <table className={'table table-earnings'}>
                  {this.renderEarningsHeader(earningsType)}
                  <tbody>{this.renderEarningsRows('surprise', earningsType)}</tbody>
                </table>
              </div>
              <div className='col-md-6 col-sm-12' style={{ paddingLeft: '0px', marginBottom: '65px' }}>
                <CurrentEarningsChart type={'salesSurprise'} />
              </div>
              <div className='col-md-6 col-sm-12' style={{ paddingLeft: '0px', marginBottom: '65px' }}>
                <CurrentEarningsChart type={'earningsSurprise'} />
              </div>
            </div>
          )}
        </div>
      )
    } else return null
  }
}

function mapStateToProps(state) {
  return {
    earningsTickerListing: state.data.earningsTickerListing,
    earningsConstituents: state.data.earningsConstituents,
    earningsAggs: state.data.earningsAggs,
    earningsType: state.data.earningsType,
    growthType: state.data.growthType,
    earningsPeriod: state.data.earningsPeriod,
    entityOption: getEntityOption(state),
    selectedRangeOption: state.data.selectedRangeOption,
    selectedEntityOption: state.data.selectedEntityOption,
    selectedPeriodOption: state.data.selectedPeriodOption,
    rangeOption: state.data.rangeOption,
    initialLoad: state.data.initialLoad,
    periodOption: getPeriodOption(state)
  }
}

export default connect(mapStateToProps, {
  setEntity,
  setPeriod,
  setRange,
  setEarningsType,
  setGrowthType
  // setConstituentNumber
})(CurrentDetailsTable)



// WEBPACK FOOTER //
// ./src/components/App/CurrentDetailsTable/CurrentDetailsTable.js